import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { storyFacts } from '@/mocks/weddingStory'

export default function WeddingStorySection() {
  const { t } = useTranslation()

  return (
    <section id="wedding-story" className="w-full bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-primary-500" />
              <span className="section-label text-primary-700 text-[11px] md:text-xs font-medium">
                {t('weddingStory.story.label')}
              </span>
            </div>

            <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 leading-tight">
              {t('weddingStory.story.title')}
            </h2>

            <p className="mt-6 text-base text-foreground-600 leading-relaxed">{t('weddingStory.story.para1')}</p>
            <p className="mt-4 text-base text-foreground-600 leading-relaxed">{t('weddingStory.story.para2')}</p>
            <p className="mt-4 text-base text-foreground-600 leading-relaxed">{t('weddingStory.story.para3')}</p>

            <div className="mt-9 rounded-lg border border-background-200 bg-background-100/60 p-6 md:p-7">
              <div className="flex items-center gap-3 mb-6">
                <span className="h-px w-8 bg-accent-500" />
                <span className="section-label text-accent-700 text-[11px] md:text-xs font-medium">
                  {t('weddingStory.facts.label')}
                </span>
              </div>
              <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-5">
                {storyFacts.map((fact) => (
                  <div key={fact.id} className="flex items-start gap-3">
                    <span className="w-10 h-10 shrink-0 rounded-full flex items-center justify-center bg-accent-100 text-accent-700">
                      <i className={`${fact.icon} text-lg`} />
                    </span>
                    <div>
                      <dt className="text-[11px] tracking-[0.12em] uppercase text-foreground-500">
                        {t(`weddingStory.facts.${fact.id}Label`)}
                      </dt>
                      <dd className="text-sm font-medium text-foreground-800 mt-0.5 leading-snug">
                        {t(`weddingStory.facts.${fact.id}Value`)}
                      </dd>
                    </div>
                  </div>
                ))}
              </dl>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="rounded-lg overflow-hidden border border-background-200 h-72 md:h-96">
              <img
                src="https://readdy.ai/api/search-image?query=happy%20South%20Indian%20Tamil%20bride%20and%20groom%20in%20traditional%20red%20silk%20saree%20and%20white%20veshti%20smiling%20together%20at%20their%20temple%20wedding%2C%20warm%20golden%20light%2C%20soft%20bokeh%20background%2C%20cinematic%20editorial%20wedding%20photography%2C%20rich%20amber%20tones&width=900&height=1100&seq=shabi-story-couple&orientation=portrait&nocache=true"
                alt="Aarthi and Karthik, a couple married in Madurai, photographed by Shabi Media"
                title="Aarthi & Karthik — temple wedding in Madurai | Shabi Media wedding photography"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <figure className="mt-5 rounded-lg border border-background-200 bg-primary-950 p-6 md:p-7">
              <div className="flex items-center justify-between mb-4">
                <i className="ri-double-quotes-l text-primary-400 text-3xl" />
                <div className="flex items-center gap-1 text-primary-400">
                  {[0, 1, 2, 3, 4].map((i) => (
                    <i key={i} className="ri-star-fill text-sm" />
                  ))}
                </div>
              </div>
              <blockquote className="font-heading italic text-lg md:text-xl text-background-100 leading-relaxed">
                {t('weddingStory.review.quote')}
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-background-50/15 flex items-center gap-3">
                <span className="w-11 h-11 rounded-full flex items-center justify-center bg-accent-500 text-background-50 font-heading text-lg font-semibold">
                  {t('weddingStory.review.name').charAt(0)}
                </span>
                <span>
                  <span className="block text-sm font-medium text-background-50">
                    {t('weddingStory.review.name')}
                  </span>
                  <span className="block text-xs text-background-300 mt-0.5">{t('weddingStory.review.role')}</span>
                </span>
              </figcaption>
            </figure>

            <Link
              to="/wedding"
              className="mt-5 inline-flex items-center justify-center gap-2 h-12 px-7 w-full rounded-md border border-background-300 text-foreground-800 text-sm font-medium tracking-wide whitespace-nowrap cursor-pointer hover:border-primary-400 hover:text-primary-700 transition-colors"
            >
              <i className="ri-arrow-left-line text-lg" />
              {t('weddingStory.backToWeddings')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}